import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { useIntl } from "react-intl";
//
import Box from "@mui/material/Box";
// component, hooks
import useLocaleRoute from "../../../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../../../hooks/useModulePublic";
import AccordionMain from "../../../../../../common/components/accordion/AccordionMain";
import AccordionSummaryTail from "./AccordionSummaryTail";
import AccordionDetailChildren from "./AccordionDetailChildren";
// store
import { StoreContext } from "../../../../../../store/StoreProvider";
// config,utils
import urls from "../../../../../../api/project/ApiUrls";
// style

const GroupMember = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user } = state;
  const { locale } = user;
  // local state
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  return (
    <Box>
      <AccordionMain
        accordionProps={{}}
        darkMode
        summaryChildren={{
          text: intl.formatMessage({
            id: "sna.sidebar.grouptool.groupmember",
            defaultMessage: "團隊成員",
          }),
          tail: <AccordionSummaryTail />,
        }}
        detailsChildren={<AccordionDetailChildren />}
        detailsProps={{}}
      />
    </Box>
  );
};

GroupMember.propTypes = {};

GroupMember.defaultProps = {};

export default GroupMember;
